import type { UserAccessType, UserType, UserTypeShort } from '@econtractor/types';

/** Службовий маркер у reject_comment для подій зміни виконавця / контролера */
export const USERS_HISTORY_MARKER = '__USERS__';

export type TaskUserRole = 'executor' | 'controller';

export const pickUserRoleAccess = (
    access?: Pick<UserAccessType, 'role' | 'team'> | null,
): Pick<UserAccessType, 'role' | 'team'> | null => {
    if (!access) return null;
    const role = access.role === 'manager' || access.role === 'executor' || access.role === 'seller'
        ? access.role
        : undefined;
    const team = Number(access.team || 0);
    if (!role && !(team > 0)) return null;
    return {
        ...(role ? { role } : {}),
        ...(team > 0 ? { team } : {}),
    };
};

export const shortUserToUserType = (user?: UserTypeShort | null): UserType | null => {
    if (!user?.ID) return null;
    return {
        ID: Number(user.ID),
        userName: String(user.userName || ''),
        userEmail: String(user.userEmail || ''),
        userPicture: String(user.userPicture || ''),
        userStatus: 1,
        admin: 0,
        userMaster: 0,
        telegram: null,
        telegramEvents: {},
        telegramId: null,
        access: pickUserRoleAccess(user.access),
        info: null,
        ...(user.teamName ? { teamName: user.teamName } : {}),
    } as UserType;
};

export const buildUsersHistoryComment = (
    roleLabel: string,
    fromName: string,
    toName: string,
): string => {
    const from = String(fromName || '').trim() || '—';
    const to = String(toName || '').trim() || '—';
    return `${USERS_HISTORY_MARKER}\n${roleLabel}: ${from} → ${to}`;
};
